import { persistentStore, sessionStore as cacheSessionStore } from 'cache/stores'

export const localStore = persistentStore
export const sessionStore = cacheSessionStore
